import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap, catchError, firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { GoogleMapsLoaderService } from './google-maps-loader.service';
import { UI_SECRET_KEYS } from '../constants/ui-secret-keys';

export interface UiSecrets {
  [key: string]: string;
}

@Injectable({
  providedIn: 'root',
})
export class UiSecretsService {
  private secrets: UiSecrets | null = null;

  constructor(
    private http: HttpClient,
    private mapsLoader: GoogleMapsLoaderService
  ) {}

  fetchSecrets(): Observable<UiSecrets | null> {
    return this.http
      .get<UiSecrets>(environment.apiUrl + '/v1/ui-secrets', {
        responseType: 'json',
      })
      .pipe(
        tap((secrets) => {
          this.secrets = secrets;
        }),
        catchError(() => {
          return of(null);
        })
      );
  }

  loadGoogleMaps(): void {
    firstValueFrom(this.fetchSecrets()).then((secrets) => {
      const apiKey = secrets?.[UI_SECRET_KEYS.GOOGLE_MAPS_API_KEY];
      if (apiKey) {
        this.mapsLoader.load(apiKey).catch((error) => { throw error; });
      }
    });
  }

  getGoogleMapsApiKey(): string | null {
    return this.secrets?.[UI_SECRET_KEYS.GOOGLE_MAPS_API_KEY] ?? null;
  }
}
